import type * as CSS from 'csstype'
import { ReactNode } from 'react'
import { Binding } from './hooks/useBinding.ts'

export function HStack(props: {
  spacing?: CSS.Property.Gap
  children: ReactNode
}) {
  return <div style={{
    display: 'flex',
    flexFlow: 'row nowrap',
    gap: props.spacing ?? '8px',
  }}>{props.children}</div>
}
export function VStack(props: {
  spacing?: CSS.Property.Gap
  children: ReactNode,
  style?: React.CSSProperties
}) {
  return <div style={{
    display: 'flex',
    flexFlow: 'column nowrap',
    gap: props.spacing ?? '8px',
    ...props.style
  }}>{props.children}</div>
}

export function Spacer(props: {
  width?: CSS.Property.Width
  height?: CSS.Property.Height
}) {
  return <div style={{
    width: props.width ?? '0px',
    height: props.height ?? '0px',
    flexGrow: 1
  }} />
}

export function Padding(props: {
  all: CSS.Property.Padding
  children: ReactNode
}): ReactNode {
  return <div style={{
    padding: props.all
  }}>{props.children}</div>
}

export function Slider(props: {
  label: string
  min: number
  $value: Binding<number>
  max: number
}): ReactNode {
  return <HStack>
    {props.label}
    <input
      type='range'
      min={props.min} max={props.max} step='any'
      value={props.$value.value}
      onChange={event => props.$value.value = event.target.valueAsNumber}
      style={{
        flexGrow: 1
      }} />
    <input
      type='button'
      value='Zero'
      onClick={() => props.$value.value = 0} />
  </HStack>
}
